import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import * as routes from '../../routes';

const AuthorCardWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 37px;
`;
const AuthorImage = styled.img`
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: block;
`;
const AuthorName = styled.p`
  color: ${(props) => props.theme.palette.text.secondary};
  margin-left: 16px;
`;
function AuthorCard({ avatar, author }) {
  return (
    <AuthorCardWrapper>
      <AuthorImage src={avatar} alt="" />
      <AuthorName>
        Post by <span>{author || 'unknow'} </span>
      </AuthorName>
    </AuthorCardWrapper>
  );
}

const LinkBlogCard = styled(Link)`
  grid-row: 1/-1;
  @media (max-width: 768px) {
    display: block;
    margin-bottom: 40px;
  }
`;
const TagCategory = styled.p`
  color: ${(props) => props.theme.palette.primary.main};
  margin-bottom: 6px;
`;
const TitleBlog = styled.h2`
  color: ${(props) => props.theme.palette.text.primary};
  font-size: 30px;
  margin-bottom: 5px;
  font-weight: 500;
`;
const DescriptionBlog = styled.p`
  color: ${(props) => props.theme.palette.text.secondary};
  font-size: 1rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-box-orient: vertical;
  box-orient: vertical;
  -webkit-line-clamp: 3;
  -moz-line-clamp: 3;
  -ms-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
`;
const BlogMainImageCard = styled.div`
  position: relative;
  height: 0;
  padding-bottom: 75%;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 26px;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    object-fit: cover;
  }
`;

function BlogMainCard({ slug, image, category, title, shortDescription, author, avatar }) {
  return (
    <LinkBlogCard to={routes.blogPost.replace(':id', slug)}>
      <BlogMainImageCard>
        <img src={image} alt="" />
      </BlogMainImageCard>
      <TagCategory>{category}</TagCategory>
      <TitleBlog>{title}</TitleBlog>
      <DescriptionBlog>{shortDescription}</DescriptionBlog>
      <AuthorCard author={author} avatar={avatar} />
    </LinkBlogCard>
  );
}

const BlogSimpleWrapper = styled(Link)`
  display: flex;
  @media (max-width: 768px) {
    margin-bottom: 40px;
    flex-direction: column;
  }
`;
const BlogSimpleImage = styled.div`
  overflow: hidden;
  width: 170px;
  height: 170px;
  border-radius: 16px;
  @media (max-width: 768px) {
    width: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const BlogSimpleContent = styled.div`
  flex: 1;
  padding: 11px 10px 20px 22px;
  @media (max-width: 768px) {
    padding-top: 26px;
  }
`;
const BlogSimpleTitle = styled.h6`
  font-size: 20px;
  margin-top: 6px;
  margin-bottom: 12px;
  font-weight: 500;
`;

function BlogSimpleCard({ slug, image, imageAlt, category, title, description }) {
  return (
    <BlogSimpleWrapper to={routes.blogPost.replace(':id', slug)}>
      <BlogSimpleImage>
        <img src={image} alt={imageAlt} />
      </BlogSimpleImage>
      <BlogSimpleContent>
        <TagCategory>{category}</TagCategory>
        <BlogSimpleTitle>{title}</BlogSimpleTitle>
        <DescriptionBlog>{description}</DescriptionBlog>
      </BlogSimpleContent>
    </BlogSimpleWrapper>
  );
}
const BlogMainList = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  grid-template-rows: auto auto auto auto auto auto;
  grid-gap: 16px;
`;
export { AuthorCard, BlogMainImageCard, BlogMainCard, BlogSimpleCard, BlogMainList };
